import React from 'react'
import { getFileIcon, formatFileSize } from '../../utils/formatHelpers'

interface AttachmentPreviewProps {
  attachments: File[]
  onRemoveAttachment: (index: number) => void
}

const AttachmentPreview = ({ attachments, onRemoveAttachment }: AttachmentPreviewProps) => {
  if (attachments.length === 0) return null

  return (
    <div
      className='tw-bg-white dark:tw-bg-slate-700/50 tw-border tw-border-slate-200 dark:tw-border-slate-600/50 tw-rounded-lg tw-p-3 tw-mb-2.5'
    >
      <h6 className='tw-text-xs tw-font-semibold tw-text-slate-700 dark:tw-text-slate-300 tw-mb-2.5 tw-uppercase tracking-wide'>
        Załączniki ({attachments.length})
      </h6>
      <div className='tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-2'>
        {attachments.map((file, index) => (
          <div
            key={index}
            className='tw-bg-slate-100 dark:tw-bg-slate-600/50 tw-rounded-md tw-p-2 tw-flex tw-items-center tw-gap-x-2'
          >
            <div className='tw-flex-shrink-0 tw-text-slate-600 dark:tw-text-slate-300'>
              <i className={`fa ${getFileIcon(file.type)} tw-text-lg fa-fw`} />
            </div>
            <div className='tw-flex-grow tw-min-w-0'>
              <p
                className='tw-text-sm tw-text-slate-800 dark:tw-text-slate-100 tw-font-medium tw-truncate'
                title={file.name}
              >
                {file.name}
              </p>
              <small className='tw-text-xs tw-text-slate-500 dark:tw-text-slate-400'>
                {formatFileSize(file.size)}
              </small>
            </div>
            <button
              type='button'
              className='tw-flex-shrink-0 tw-ml-1 tw-p-1 tw-text-red-500 hover:tw-text-red-700 hover:tw-bg-red-100 dark:hover:tw-bg-red-900/50 tw-rounded-full focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-red-500 transition-colors'
              onClick={() => onRemoveAttachment(index)}
              aria-label='Usuń załącznik'
            >
              <i className='fa fa-times tw-text-xs' />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AttachmentPreview
